import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./client/store/slice/userSlice";
import dashboardReducer from './client/store/slice/dashboardSlice';
import { setupListeners } from "@reduxjs/toolkit/query";
import { userApi } from "./client/store/services/user";
import { dashboardApi } from "./client/store/services/dashboard";

export const store = configureStore({
    reducer: {
        users: userReducer,
        dashboard: dashboardReducer,
        [userApi.reducerPath]: userApi.reducer,
        [dashboardApi.reducerPath]: dashboardApi.reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([userApi.middleware, dashboardApi.middleware])
});
setupListeners(store.dispatch);